module.exports = [
  {
    title: {
      zh: '學以致用　嶄露頭角',
      en: 'IFT Students Shine in Macao MICE Competition',
    },
    content: {
      zh: [
        '由澳門會議展覽業協會主辦的“2017/2018澳門大專院校學生會議活動策劃比賽”決賽於2018年3月17日進行。兩支代表隊由學院的旅遊會展及節目管理學生組成，在11支來自不同院校的隊伍中脫穎而出，奪得比賽冠軍和季軍。',
        '獲獎團隊的提議是建立了他們提出的國際美食旅遊共創論壇，認為澳門提供的美食可吸引旅客。參賽的同學表示，參加是次比賽獲益良多，可以將課堂的知識學以致用。',
      ],
      en: [
        "A team of IFT students won the Macao Tertiary Institution Students Conference Challenge 2017/18 on 17 March 2018 and another finished third in the field out of 11 competing teams. Both IFT teams were made up of students pursuing a Bachelor of Science in Tourism Event Management.",
        "The winning team’s proposal established what they called the International Gastronomy Tourism Co-creation Forum and argued that the food a place such as Macao offers will attract tourists and should be regarded as more than just a side attraction. The students described the contest as a good learning experience and a way to apply what they have learned in the classroom in a practical exercise. They added that joining this competition improved their understanding of how to put together an event.",
      ],
    },
  },
  {
    title: {
      zh: '創新創意　頗受認可',
      en: 'IFT Team Secures Podium Spot in Regional Marketing Competition',
    },
    content: {
      zh: [
        '由學院學生組成的隊伍“Rocky N’Girls”於麗新橫琴創新方主辦的“2018智匯大灣商業挑戰賽”中勇奪第三名。是次比賽的各參賽者提交了為期6個月的創新方市場計劃，並以吸引大灣區年輕人和家庭客為目標，優勝隊伍獲得該年度創新方管理培訓計劃的面試直通卡，在不同部門及項目工作。',
        '“Rocky N’Girls”提議使用快閃形式，並利用街道的虛擬實景體驗吸引旅客，其創新性及可行性廣受肯定。最終，團隊不僅贏得了人民幣3,000元的現金獎勵，也獲得前往台灣醫療集團訪問的機會。',
      ],
      en: [
        "A team of 5 IFT students, “Rocky N’Girls”, claimed third place in the “Novotown University Business Case Competition 2018”, a marketing competition held by a unit of Hong Kong’s Lai Sun Group. Participants were required to present a 6-month marketing plan to promote Novotown, a multi-phase integrated tourism and entertainment project under development in the neighbouring Hengqin Island, in Guangdong Province.",
        "Rocky N’Girls proposed the use of flash mob events and of street-based virtual reality experiences to draw visitor interest to Novotown and was praised for its creativity and its feasibility in terms of implementation. They won a RMB3,000 cash prize and a trip in June to visit the operations of Taiwan-based healthcare group Sanitas.",
      ],
    },
  },
  {
    title: {
      zh: '慢食文化　支援公益',
      en: 'Slow Food Gala Dinner: A delicious success',
    },
    content: {
      zh: [
        '旅遊會展及節目管理學士學位課程二年級學生與澳門慢食文化協會於2017年11月24日在旅遊學院教學餐廳舉辦“澳門慢食文化週年晚宴2017”。整個活動由該課程學生負責策劃和舉辦，向購票入場的賓客推廣“慢食”的意義。活動扣除開支後，共有澳門幣14,925.70元的收益，已全數撥捐澳門珍惜食非牟利組織，支持其減少食物浪費的工作。',
      ],
      en: [
        "A group of Year 2 IFT students studying for the Bachelor of Science in Tourism Event Management held the Macau Slow Food Gala Dinner 2017 with the help of the Macau Slow Food Association at the IFT Educational Restaurant on 24 November. They undertook the project entirely on their own initiative to promote the Slow Food Movement. The event was funded by ticket sales and sponsorships. A net profit of MOP14,925.70 was donated to WeFood Macau, a local non-profit organisation that works to reduce food wastage.",
      ],
    },
  },
  {
    title: {
      zh: '文遺管理　課程實踐',
      en: 'Cultural Heritage Management Course Practicum',
    },
    content: {
      zh: [
        '澳門旅遊學院協辦的“遺城春秋——鄭家大屋的前世今生”於2017年10月舉行，活動由文化遺產管理和旅遊會展及節目管理兩個學位課程聯合舉辦。在課程中，學生可以學習、構思、計劃、管理和執行活動，並在活動之後檢討流程。同時，學生也在實踐中應用文化遺產管理知識，採用不同方式，如透過影片播放、導覽、各式展覽和互動體驗等，為市民及旅客講解鄭家大屋歷史。',
      ],
      en: [
        "Coorganised by IFT, “The Memory of Mandarin’s House” was held in October 2017. The event was jointly organised by 2 courses, namely Heritage Interpretation and Event Management. In the course, students learnt, thought, planned, managed and executed activities, and reviewed the process after the event. At the same time, students also put cultural heritage management knowledge into practice using different methods, such as video playback, guided tours, various exhibitions and interactive experiences to tell the history of the Mandarin’s House to the public and tourists.",
      ],
    },
    video: {
      zh: 'https://player.youku.com/embed/XNDE5MzMyMDgxMg==',
      en: 'https://www.youtube.com/embed/HsoZCVUdNgw',
    }
  },
  {
    title: {
      zh: '漫步遊澳門',
      en: 'Tour around Macao with IFT Students',
    },
    content: {
      zh: [
        '學士學位課程的設計是理論與實踐並重，故學生每年均需在其主修專業範疇內完成一定時數的實踐工作。修讀旅遊企業管理學生其中一個實踐工作，是以“旅遊學院學生帶您漫步遊澳門”為題，為旅客及本澳市民提供免費導遊服務。',
        '是次活動的四條觀光路線由計劃路線、安排導覽時間表以至實際導遊工作均是由學生們自行安排，導師只是從旁輔助，這樣可使他們從策劃過程中學習各種溝通技巧，以及藉著學生於市內、名勝及旅遊景點提供服務的同時，亦可作為對澳門市民的一種宣傳，令普羅大眾意識到旅遊業的重要性及對旅客宣傳澳門。',
      ],
      en: [
        "Bachelor’s degree programmes at IFT accommodate both theoretical and practical needs of the students and so students are required to complete a certain amount of hands-on learning tasks in their majors every year. One of those tasks for those who study Tourism Business Management is to give tourists and local Macao citizens free guided tour service. In 2017, IFT students provided free guided tours to visitors and Macao citizens with the theme “Tour around Macao with IFT Students”.",
        "The project included the planning of four sightseeing routes, the scheduling of timetable and the actual tour-guiding work which were all done by the students themselves, with little assistance from their tutors. Students learnt various communication skills from the planning process, and by providing services to tourists on tourist attractions, they also made the general public in Macao aware of the importance of tourism in Macao.",
      ],
    },
    video: {
      zh: 'https://player.youku.com/embed/XNDE5MzMxOTA4MA==',
      en: 'https://www.youtube.com/embed/RfHFRZg2EGk',
    }
  },
  {
    title: {
      zh: '夜遊澳門世遺',
      en: 'Visiting the World Heritage by Night',
    },
    content: {
      zh: [
        '管理學原理作為旅遊零售及市場推廣管理夜間學位的課程內容之一，主要圍繞著管理的四大方向，分別是計劃、組織、領導及管理。2017年9月，該課程的學生舉辦“夜遊世遺”活動，由學生根據各自興趣以及課程所學，分組設計與眾不同的旅遊路線。導師及學生共同投票選出最好的一組，勝出的小組獲機會實踐計劃書內的行程。活動有利於實踐課堂所學，同時推廣澳門文化遺產，令旅客及市民認識到不一樣的澳門。',
      ],
      en: [
        "“Principles of Management”, a course in IFT’s evening bachelor degree programme Tourism Retail and Marketing Management, focuses on the main functions of managers: planning, organisation, leadership and control. In September 2017, students in it were divided into groups and each group was asked to present a proposal for a field trip under the theme “Visiting the World Heritage by Night”. The group that created the winning proposal was given the chance to put it into action, while each of the other groups wrote reports on the project. The project offered students a chance to apply what they had learned in class while showing tourists and local Macao citizens a different Macao.",
      ],
    },
    video: {
      zh: 'https://player.youku.com/embed/XMzQ3NzQ5MzYzNg==',
      en: 'https://www.youtube.com/embed/KcKGUM5ETIg',
    }
  },
  {
    title: {
      zh: '志願服務　走出澳門',
      en: 'IFT Volunteer Circle attends forum in Japan',
    },
    content: {
      zh: [
        '旅遊學院青年卓越服務團獲邀於2018年3月2至4日，到日本東京出席“第六屆全國學生志願者和支持者研究交流論壇”，這是旅遊學院連續第3年獲得日本國立青少年教育振興機構的邀請。',
      ],
      en: [
        "Members of the IFT Volunteer Circle attended the 6<sup>th</sup> National Research Exchange Forum for Volunteer Students and Supporters, held in Tokyo, Japan from 2 to 4 March 2018. They were invited by the National Institution for Youth Education of Japan, for the third successive year.",
        "The delegation from Macao consisted of 12 members of the IFT Volunteer Circle and 4 students of the University of Macau, and was sponsored in part by Macao’s Tertiary Education Services Office (GAES). In the forum, 12 workshops on various aspects of contributing to society and student empowerment were held and participants exchanged experience and thoughts on volunteerism. The Forum brought together 901 students and supporters from 171 institutions of higher education.",
      ],
    },
  },
]
